type ResolveMetricsPageToolbarLayoutArgs = {
  allowWrappedHeader: boolean;
  showToolbarControls: boolean;
  hasHeaderRightSlot: boolean;
  showInlineFilters: boolean;
  inlineFilterControlCount: number;
  collapseAtXl: boolean;
  collapseAtLg: boolean;
  collapseAtMd: boolean;
};

export type MetricsPageToolbarLayout = {
  isCompactHeaderLayout: boolean;
  useWrappedHeaderLayout: boolean;
  useCollapsedToolbarControls: boolean;
};

export type MetricsPageToolbarHeaderSlotLayout = {
  shouldRenderHeaderRightSlot: boolean;
  justifyContent: 'flex-start' | 'flex-end';
  width: '100%' | 'auto';
  flex: '1 1 100%' | '1 1 320px' | '0 0 auto';
  useControlsOffsetMargin: boolean;
  useHeaderTitlePaddingLeft: boolean;
};

export const resolveMetricsPageToolbarLayout = (
  input: ResolveMetricsPageToolbarLayoutArgs,
): MetricsPageToolbarLayout => {
  const {
    allowWrappedHeader,
    showToolbarControls,
    hasHeaderRightSlot,
    showInlineFilters,
    inlineFilterControlCount,
    collapseAtXl,
    collapseAtLg,
    collapseAtMd,
  } = input;

  const isCompactHeaderLayout = !showToolbarControls && hasHeaderRightSlot && collapseAtLg;
  const useWrappedHeaderLayout = allowWrappedHeader && !showToolbarControls && hasHeaderRightSlot;
  const useCollapsedToolbarControls =
    showInlineFilters &&
    (inlineFilterControlCount >= 3
      ? collapseAtXl
      : inlineFilterControlCount >= 2
        ? collapseAtLg
        : collapseAtMd);

  return {
    isCompactHeaderLayout,
    useWrappedHeaderLayout,
    useCollapsedToolbarControls,
  };
};

export const resolveMetricsPageToolbarHeaderSlotLayout = ({
  hasHeaderRightSlot,
  isCompactHeaderLayout,
  showToolbarControls,
  useWrappedHeaderLayout,
}: {
  hasHeaderRightSlot: boolean;
  isCompactHeaderLayout: boolean;
  showToolbarControls: boolean;
  useWrappedHeaderLayout: boolean;
}): MetricsPageToolbarHeaderSlotLayout => ({
  shouldRenderHeaderRightSlot: !showToolbarControls && hasHeaderRightSlot,
  justifyContent: isCompactHeaderLayout || !useWrappedHeaderLayout ? 'flex-start' : 'flex-end',
  width: isCompactHeaderLayout ? '100%' : 'auto',
  flex: isCompactHeaderLayout ? '1 1 100%' : useWrappedHeaderLayout ? '1 1 320px' : '0 0 auto',
  useControlsOffsetMargin: !isCompactHeaderLayout,
  useHeaderTitlePaddingLeft: isCompactHeaderLayout,
});
